import React from 'react';
import useSWR from "swr";
import {withoutAuthFetcher} from "../../utils/api.ts";
import {useDebounce} from '@uidotdev/usehooks'
interface PreviewResponse {
    preview: string, title: string, url: string, description: string
}
function UrlPreview({url, display = "facebook"}:{
    display: 'twitter' | 'facebook'
    url: string;
}) {
    const val = useDebounce(url, 2000)
    const {data, isLoading} = useSWR<PreviewResponse>(val ? `/utils/preview?url=${val}` : null, withoutAuthFetcher)
    if(!url) return null;
    if(display === 'twitter'){
        return <TwitterStyleDisplay is_loading={isLoading} {...data} />
    }else {
        return <FacebookStyleDisplay is_loading={isLoading} {...data} />
    }
}
function FacebookStyleDisplay(props: PreviewResponse & {is_loading:boolean}) {
    const {
        is_loading, preview, url, title, description
    } = props;
    return <div
        className={is_loading ? "placeholder placeholder-wave overflow-hidden" : 'overflow-hidden'}>
        <img
            alt={"Website preview"}
            src={preview} style={{width: '100%', objectFit: 'cover', aspectRatio: '16/9'}}/>
        <div className={"p-2 bg-base-300"}>
            {
                url ?
            <div className={"ellipsis text-muted"} style={{fontSize: '.9rem'}}>
                {new URL(url).hostname.replace('www.', '').toUpperCase()}
            </div> : null
            }
            <div className={"fs-6 line-clamp-1"} style={{fontWeight: 500}}>{title}</div>
            <small className={"line-clamp-1"}>{description}</small>
        </div>
    </div>
}

function TwitterStyleDisplay(props: PreviewResponse & {is_loading:boolean}) {
    const {
        is_loading, preview, url, title, description
    } = props;
    return <div className={is_loading ? 'skeleton' : ''}>
        <div className={"rounded-xl overflow-hidden relative"}>
            <img
                alt={url}
                src={preview}
                 style={{width:'100%', aspectRatio:'16/9', objectFit:'cover'}} />
            <span className={"bg-black/70 rounded text-white line-clamp-1 px-2 text-sm absolute ml-2 mr-2"} style={{bottom:10}}>{title}</span>
        </div>
        {
            url ? <span className={"text-sm opacity-50"}>From {new URL(url).hostname}</span> : null
        }
    </div>
}

export default UrlPreview;
